import type { IconData } from '@stacksjs/iconify-core'

export const table: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M8.257 44.461c-2.555-.208-4.51-2.163-4.718-4.718C3.277 36.515 3 31.364 3 24s.277-12.515.539-15.743c.208-2.555 2.163-4.51 4.718-4.718C11.485 3.277 16.636 3 24 3s12.515.277 15.743.539c2.555.208 4.51 2.163 4.718 4.718C44.723 11.485 45 16.636 45 24s-.277 12.515-.539 15.743c-.208 2.555-2.163 4.51-4.718 4.718C36.515 44.723 31.364 45 24 45s-12.515-.277-15.743-.539m6.743.383V3.154M3.25 17h41.5M3.25 31h41.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default table
